import styled, { css } from 'styled-components';
import { rem, em } from 'polished';
import { media } from 'core/layout';
import { colors, accessibilityBorder } from 'core/theme';

export const StyledContentP = styled.p`
  ${({ width }) => width && css`
    width: ${width * 100}%;
  `};

  ${media.tablet`
    width: 100%;
  `};

  a {
    color: ${colors.primary};
  }
`;

export const StyledContent = styled.article`
  margin-top: 2.5em;
  margin-bottom: 2.5em;

  ${({ width }) => width && css`
    width: ${width * 100}%;
  `};

  p {
    color: ${colors.text};
  }

  h1:first-child {
    margin-bottom: 1em;
  }

  h3:first-child {
    margin-bottom: 1em;
  }

  ${media.tablet`
    font-size: ${20 / 24}rem;
    width: 100%;
  `};
`;

export const Label = styled.label`
  pointer-events: none;
  color: ${colors.subtleText};
  font-size: ${rem(14)};
  margin-bottom:${rem(8)};
  display:block;
`;

export const Form = styled.div`
  position: relative;

  ${({ width }) => width && css`
    width: ${width * 100}%;
  `};

  & > form > div {
    margin-bottom: 0;
  }

  input, textarea {
    background-color: ${colors.background};
    border: 1px solid #E0E0E0;
    border-radius: 2px;
    color: ${colors.text};
    font-size: ${em(16)};
    width: 100%;
    padding: 0.5em 1em;

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }

    &::-ms-clear {
      display: none;
    }

    ${accessibilityBorder};
  }


  ${media.tablet`
    width: 100%;
    form {
      padding-bottom:70px;
    }

    input {
      margin-bottom: 1em;
    }

    button {
      margin-bottom: 1em;
      min-width: 50%;
    }
  `};

  ${media.mobile`
     form {
      padding-bottom:70px;
    }
    button {
      min-width: 0;
      width: 100%;
    }
  `};
`;

export const Atsauce = styled.div`
  color: ${colors.subtleText};
  font-size: ${em(14)};

  ${media.tablet`
    margin-bottom: 1.5em;
  `};
`;

export const RecaptchaContainer = styled.div`
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
    z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/modules/FeedbackForm/styled.js